import Flex from '../flex-container';

export default {
  name       : 'Column',
  components : {
    Flex
  },
  props: {
    items              : null,
    academicMainId     : null,
    academicMainTypeId : null
  }
};
